import { Button, Group, Loader, Stack, Text } from '@mantine/core'

import dayjs from 'src/common/libs/dayjs'

import { useGetNycLookupLicenseQuery } from '@v2/domains/documents/api/documents.api'

interface NycLicenseLookupResultProps {
  findBy: string
  findValue: string
}

const formatDate = (date?: string) =>
  dayjs(date?.split('T')[0]).format('MMM DD, YYYY')

const NycLicenseLookupResult = ({
  findBy,
  findValue,
}: NycLicenseLookupResultProps) => {
  const {
    currentData: data,
    isFetching,
    isError,
    refetch,
  } = useGetNycLookupLicenseQuery(
    { findBy, findValue },
    { skip: !findBy || !findValue },
  )

  return (
    <Stack data-testid="nyc-license-lookup-results-list" gap="xs">
      {isFetching && !data ? (
        <Loader
          data-testid="nyc-license-lookup-loading-label"
          aria-label="Loading NYC lookup"
        />
      ) : isError && !data ? (
        <>
          <Text data-testid="nyc-license-lookup-error-label" c="red">
            Unable to load NYC Open Data lookup
          </Text>
          <Button
            data-testid="nyc-license-lookup-retry-button"
            onClick={() => refetch()}
          >
            Retry
          </Button>
        </>
      ) : !data?.id ? (
        <Text data-testid="nyc-license-lookup-not-found-label" c="red">
          Driver is not found in NYC Open Data
        </Text>
      ) : (
        <Stack data-testid="nyc-license-lookup-result-card" gap="xs">
          <Text data-testid="nyc-license-lookup-driver-label" c="blue" fw={600}>
            {data.name} - {data.licenseNumber}
          </Text>
          <Group justify="space-between">
            <Text size="sm">Expiration date:</Text>
            <Text size="sm" data-testid="nyc-license-lookup-expiration-label">
              {formatDate(data.expirationDate)}
            </Text>
          </Group>
          <Group justify="space-between">
            <Text size="sm">Last Update:</Text>
            <Text size="sm" data-testid="nyc-license-lookup-updated-label">
              {formatDate(data.lastDateUpdated)}
            </Text>
          </Group>
          <Text
            data-testid="nyc-license-lookup-status-label"
            c={data.isActive ? 'green' : 'red'}
            fw={700}
          >
            {data.isActive ? 'ACTIVE' : 'INACTIVE'}
          </Text>
        </Stack>
      )}
    </Stack>
  )
}

export default NycLicenseLookupResult
